<template>
  <main>
    <div
      class="text-center py-5 my-5"
    >
      <b-spinner
        variant="primary"
        label="Spinning"
        class="mt-2"
      />
    </div>
  </main>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { getHomeRouteForLoggedInUser, getUserData } from '@/auth/utils'

import { BSpinner } from 'bootstrap-vue'

export default {
  components: {
    BSpinner,
  },
  computed: {
  },
  created() {
    const userData = getUserData()
    this.$router.replace(getHomeRouteForLoggedInUser(userData.roles))
  },
  methods: {
  },
}
</script>
